import React, { useMemo, useState } from 'react'
import Grid from '@material-ui/core/Grid/index'
import withStyles from '@material-ui/core/styles/withStyles'
import { getStyles } from 'isotope-client'
import Stats from './synthese/Stats'
import PlanificationVsCharge from './synthese/PlanificationVsCharge'
import TachesReportOuAnticipation from './synthese/TachesReportOuAnticipation'
import TachesParFamille from './synthese/TachesParFamille'
import { getSyntheseDatas, getSyntheseDetailDatas } from '../services/api'
import LoaderAdvanced from 'react-loader-advanced'
import Switch from '../../../../components/Switch'
import Typography from '@material-ui/core/Typography/index'
import Button from '@material-ui/core/Button'
import ZoomInIcon from '@material-ui/icons/ZoomIn'
import { FormattedMessage } from 'react-intl'
import { useGestionTacheContext } from '../GestionTacheProvider'
import { ETAT_TACHE_UPPERCASE, ONGLET_GESTION_TACHE } from '../../../../utils/constants'
import { injectPlanificationFilter } from '../injectors/filterInjector'
import { compose } from 'redux'
import { saveCurrentFilter, setFilterUsed } from '../../planning/services/toolbar/toolbarAction'
import { connect } from 'react-redux'
import { FILTER_FIELDS } from '../form/FilterForm'
import CircularProgress from '@material-ui/core/CircularProgress'
import SemainesNonInitialisees from './common/SemainesNonInitialisees'
import { getSyntheseResultatDatas, getSyntheseResultatDetailDatas } from '../services/resultatApi'
import { useSolverStatusContext } from '../../besoinsProduction/SolverStatusContextProvider'
import { SOLVER_TASK_PERIOD } from '../services/gestionTache.consts'

const styles = (theme) => getStyles({
	withBorder: {
		border: '0.5px solid lightgray'
	},
	link: {
		color: theme.palette.primary.main,
		textTransform: 'none'
	}
})

const TACHE_TYPE_SWITCH = [
	{
		id: 'tachesPlanifiees',
		tachesPlanifiees: true,
		label: 'gestionTaches.ecranSynthese.details.type.tachesPlanifiees'
	},
	{
		id: 'tachesNonPlanifiees',
		tachesPlanifiees: false,
		label: 'gestionTaches.ecranSynthese.details.type.tachesNonPlanifiees'
	}
]

const SyntheseOnglet = ({ classes, saveCurrentFilter, setFilterUsed }) => {

	const [datas, setDatas] = useState(undefined)
	const [loading, setLoading] = useState(false)
	const [loadingDetails, setLoadingDetails] = useState(false)
	const [detailDatas, setDetailDatas] = useState(undefined)
	const [tachesPlanifiees, setTachesPlanifiees] = useState(TACHE_TYPE_SWITCH[0].tachesPlanifiees)
	const { setOnglet, isResultat } = useGestionTacheContext()
	const { solverTachePeriod } = useSolverStatusContext()

	React.useEffect(() => {
		setLoading(true)
		if (isResultat) {
			getSyntheseResultatDatas(false).then(setDatas).finally(() => setLoading(false))
		} else {
			getSyntheseDatas(false).then(setDatas).finally(() => setLoading(false))
		}
	}, [isResultat])

	React.useEffect(() => {
		setLoadingDetails(true)
		if (isResultat) {
			getSyntheseResultatDetailDatas(tachesPlanifiees).then(setDetailDatas).finally(() => setLoadingDetails(false))
		} else {
			getSyntheseDetailDatas(tachesPlanifiees).then(setDetailDatas).finally(() => setLoadingDetails(false))
		}
	}, [tachesPlanifiees, isResultat])

	const legendNbWeeks = useMemo(() => isResultat && solverTachePeriod === SOLVER_TASK_PERIOD.DAYS ? 1 : 3, [isResultat, solverTachePeriod])

	return (
		<LoaderAdvanced
			show={!datas || !detailDatas || loading || loadingDetails}
			message={<CircularProgress />}
			backgroundStyle={{ backgroundColor: 'rgba(255,255,255,0.5)' }}
		>
			<Grid container item direction="column" style={{ padding: '1%', gap: 20 }}>
				{datas && <SemainesNonInitialisees datas={datas} />}
				{datas && <Grid container item>
					<Grid container item direction="column" justify="center" lg={4} md={12} style={{ gap: 15, marginBottom: 20 }}>
						<Stats datas={datas.stats} legendNbWeeks={legendNbWeeks} />
					</Grid>
					<Grid container item lg={8} md={12} className={classes.withBorder}>
						<PlanificationVsCharge datas={datas.planificationVsCharge} />
					</Grid>
				</Grid>}
				{detailDatas && <Grid container item direction="column" className={classes.withBorder} style={{ padding: 20 }}>
					<Grid container item>
						<Grid container item justify="flex-start" alignItems="center" xs={4}>
							<Switch
								items={TACHE_TYPE_SWITCH}
								setValue={(item) => setTachesPlanifiees(item.tachesPlanifiees)}
								defaultValue={TACHE_TYPE_SWITCH[0]}
								additionalStyle={{ width: 130, padding: 0 }}
							/>
						</Grid>
						<Grid container item justify="center" alignItems="center" xs={4}>
							<Typography variant="h2"><b><FormattedMessage id="gestionTaches.ecranSynthese.details.title" /></b></Typography>
						</Grid>
						<Grid container item justify="flex-end" alignItems="center" xs={4}>
							<Button onClick={() => {
								if (tachesPlanifiees) {
									saveCurrentFilter({
										[FILTER_FIELDS.STATUT.name]: [
											ETAT_TACHE_UPPERCASE.A_REALISER,
											ETAT_TACHE_UPPERCASE.EN_COURS,
											ETAT_TACHE_UPPERCASE.EN_PAUSE,
											ETAT_TACHE_UPPERCASE.EN_ATTENTE,
											ETAT_TACHE_UPPERCASE.TERMINEE
										]
									})
								} else {
									saveCurrentFilter({
										[FILTER_FIELDS.STATUT.name]: [ETAT_TACHE_UPPERCASE.A_PLANIFIER]
									})
								}
								setFilterUsed(true)
								setOnglet(ONGLET_GESTION_TACHE.PLANIFICATION)
							}} className={classes.link}>
								<ZoomInIcon />
								<Typography className={classes.link}>
									<FormattedMessage id="gestionTaches.ecranSynthese.details.link" />
								</Typography>
							</Button>
						</Grid>
					</Grid>
					<Grid container item alignItems="flex-start">
						<Typography style={{ fontSize: 12, color: 'gray', marginTop: 8, whiteSpace: 'break-spaces' }}>
							<FormattedMessage id="gestionTaches.ecranSynthese.details.subtitle" values={{ nbWeeks: legendNbWeeks }} />
						</Typography>
					</Grid>
					<Grid container item>
						<Grid container item lg={6} md={12}>
							<TachesReportOuAnticipation
								datas={detailDatas.tachesReportAnticipation}
								isTachesPlanifiees={tachesPlanifiees}
								legendNbWeeks={legendNbWeeks}
							/>
						</Grid>
						<Grid container item lg={6} md={12}>
							<TachesParFamille
								datas={detailDatas.tachesParFamille}
								isTachesPlanifiees={tachesPlanifiees}
								legendNbWeeks={legendNbWeeks}
							/>
						</Grid>
					</Grid>
				</Grid>}
			</Grid>
		</LoaderAdvanced>
	)
}

const actions = {
	saveCurrentFilter,
	setFilterUsed
}

export default compose(
	connect(undefined, actions),
	withStyles(styles),
	injectPlanificationFilter
)(SyntheseOnglet)